import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstanceAuth } from "../../../../Utils/AxiosInstance";
import { revertAll } from "../../ResetStateAction";

const initialState = {
  User: [],
  UserPopulate: [],
  SingleUser: null,
  UserRoles: [],
  CurrentUser: [],
  UsersOverview: [],
  isSuccess: false,
  message: null,
  status: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  status1: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'

  error: null,
  IsLogin: true,
};

// export const fetchUser = createAsyncThunk("/Users", async () => {
//   const response = await axiosInstanceAuth.get(`/Users`);

//   return response.data;
// });
export const fetchUser = createAsyncThunk("/Users", async (module = "CRM", { rejectWithValue }) => {
  try {
    const response = await axiosInstanceAuth.get(`/Users?Module=${module}`);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || "Failed to fetch users");
  }
});

export const fetchUserPopulate = createAsyncThunk("/Users/Populate", async () => {
  const response = await axiosInstanceAuth.get(`/Users/Populate`);

  return response.data;
});

export const fetchSingleUser = createAsyncThunk(
  "users/fetchById",
  async (id) => {
    const response = await axiosInstanceAuth.get(`/users/byId/${id}`);
    return response.data;
  }
);

// export const fetchSingleUser = createAsyncThunk("/Users/byId", async id => {
//   const response = await axiosInstanceAuth.get(`/Users/byId/${id}`);

//   return response.data;
// });

export const fetchUserRoles = createAsyncThunk("users/fetchUserRoles", async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstanceAuth.get(`/Users/UserRoles/${id}`);
    return response.data;
  } catch (err) {
    return rejectWithValue({
      status: err.response?.status,
      errorCode: err.response?.data?.ErrorCode,
      message: err.response?.data?.Message || err.message || "Something went wrong",
    });
  }
});

export const fetchCurrentUser = createAsyncThunk("/Users/Current", async (module = "CRM", { rejectWithValue }) => {
  try {
    const response = await axiosInstanceAuth.get(`/Auth/GetCurrentUserInfo?Module=${module}`);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || "Failed to fetch user");
  }
});

export const fetchUsersOverview = createAsyncThunk(
  "/Users/GetUsersOverview",
  async ({ pageNumber = 1, pageSize = 100 } = {}) => {
    const response = await axiosInstanceAuth.get(`/Users/GetUsersOverview`, {
      params: {
        PageNumber: pageNumber,
        PageSize: pageSize,
      },
    });

    return response.data;
  },
);
const UserSlice = createSlice({
  name: "User",
  initialState,
  reducers: {
    UserAdded: {
      reducer(state, action) {
        state.User?.push(action.payload);
      },
    },
    resetUserSlice: () => initialState,
  },
  extraReducers(builder) {
    builder
      .addCase(revertAll, () => initialState)
      .addCase(fetchUser.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.User = action.payload.Data;
      })
      .addCase(fetchUser.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      })
      .addCase(fetchSingleUser.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchSingleUser.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.SingleUser = action.payload.Data;
      })
      .addCase(fetchSingleUser.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      })
      .addCase(fetchUserRoles?.pending, state => {
        state.status1 = "loading";
      })
      .addCase(fetchUserRoles?.fulfilled, (state, action) => {
        state.status1 = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.UserRoles = action.payload.Data;
      })
      .addCase(fetchUserRoles?.rejected, (state, action) => {
        state.error = action.error.message;
        state.status1 = "failed";
      })
      .addCase(fetchUserPopulate?.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchUserPopulate?.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.UserPopulate = action.payload.Data;
      })
      .addCase(fetchUserPopulate?.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      })
      .addCase(fetchCurrentUser?.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchCurrentUser?.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.CurrentUser = action.payload;
      })
      .addCase(fetchCurrentUser?.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      })
      .addCase(fetchUsersOverview?.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchUsersOverview?.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.UsersOverview = action.payload;
      })
      .addCase(fetchUsersOverview?.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      });
  },
});

export const getUserDetails = state => state.User;

export const { UserAdded, resetUserSlice } = UserSlice.actions;

export default UserSlice.reducer;
